import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSeededit3dStyleParams {
  /**
   * 请求键，必填，指定要使用的3D风格
   */
  req_key: string;
  /**
   * 子请求键，某些req_key需要此参数来指定具体子风格
   */
  sub_req_key?: string;
  /**
   * Base64编码的图像数据数组，必须包含 exactly 1 个图像
   */
  binary_data_base64?: string[];
  /**
   * 图像URL数组，必须包含 exactly 1 个图像
   */
  image_urls?: string[];
  /**
   * 是否返回图像URL，默认值为true
   */
  return_url?: boolean;
  /**
   * 水印信息
   */
  logo_info?: {
    /**
     * 是否添加水印
     */
    add_logo?: boolean;
    /**
     * 水印位置
     */
    position?: number;
    /**
     * 水印语言
     */
    language?: number;
    /**
     * 水印透明度
     */
    opacity?: number;
    /**
     * 水印文字内容
     */
    logo_text_content?: string;
  };
}

export interface VolcesSeededit3dStyleResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_seededit_3d_style
 *
 * 通过火山引擎SeedEdit 3D Style API创建3D风格生成任务。[API Documentation](https://www.volcengine.com/docs/86081/1660199)
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSeededit3dStyle } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesSeededit3dStyle({
 *   // 参数见 VolcesSeededit3dStyleParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSeededit3dStyleParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSeededit3dStyle(
  params: VolcesSeededit3dStyleParams,
): Promise<VolcesSeededit3dStyleResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 4000,
    maxAttempts: 90,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seededit_3d_style',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeededit3dStyleResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
